import {type} from '@ngrx/signals';
import {event} from '@ngrx/signals/events';

export const AppErrorEvent = (errorType?: string) =>
  event(`[App] Error${errorType ? ' ' + errorType : ''}`, type<unknown>());
